import { AnyAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { all, getContext, put, takeEvery } from 'redux-saga/effects';
import { SceneCardService } from '../service/scene-card-service';
import { SceneTagService } from '../service/scene-tag-service';
import { ScenesGroupService } from '../service/scenes-group-service';
import {
	addSceneCard,
	addSceneCardFailure,
	addSceneCardSuccess,
	addSceneTag,
	addSceneTagFailure,
	addSceneTagSuccess,
	addScenesGroup,
	addScenesGroupFailure,
	addScenesGroupSuccess,
	deleteSceneCard,
	deleteSceneCardFailure,
	deleteSceneCardSuccess,
	deleteSceneTag,
	deleteSceneTagFailure,
	deleteSceneTagSuccess,
	deleteScenesGroup,
	deleteScenesGroupFailure,
	deleteScenesGroupSuccess,
	getSceneCardToUpdate,
	getSceneCardToUpdateFailure,
	getSceneCardToUpdateSuccess,
	getSceneCards,
	getSceneCardsFailure,
	getSceneCardsSuccess,
	getSceneTagToUpdate,
	getSceneTagToUpdateFailure,
	getSceneTagToUpdateSuccess,
	getSceneTags,
	getSceneTagsFailure,
	getSceneTagsSuccess,
	getScenesGroupToUpdate,
	getScenesGroupToUpdateFailure,
	getScenesGroupToUpdateSuccess,
	getScenesGroups,
	getScenesGroupsFailure,
	getScenesGroupsSuccess,
	searchSceneCards,
	searchSceneTags,
	searchScenesGroups,
	setSearchSceneCardsAutoCompleteResult,
	setSearchSceneTagsAutoCompleteResult,
	setSearchScenesGroupsAutoCompleteResult,
	updateSceneCard,
	updateSceneCardFailure,
	updateSceneCardSuccess,
	updateSceneTag,
	updateSceneTagFailure,
	updateSceneTagSuccess,
	updateScenesGroup,
	updateScenesGroupFailure,
	updateScenesGroupSuccess,
} from './slice';

function* getSceneTagsListHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SceneTagService(globalApplicationContext);
		const data = yield sentenceService.getSceneTags(
			action.payload.page,
			action.payload,
		);
		yield put(getSceneTagsSuccess(data));
	} catch (e) {
		yield put(getSceneTagsFailure(e));
		console.error(e);
	}
}

function* searchSceneTagsHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SceneTagService(globalApplicationContext);
		const data = yield sentenceService.searchSceneTagsAutoComplete(
			action.payload,
		);
		yield put(setSearchSceneTagsAutoCompleteResult(data));
	} catch (e) {
		console.error(e);
	}
}

function* deleteSceneTagHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SceneTagService(globalApplicationContext);
		yield sentenceService.deleteSceneTag(action.payload);
		yield put(deleteSceneTagSuccess({}));
		toast('Scene tag deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteSceneTagFailure(e));
		console.error(e);
	}
}

function* addSceneTagHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SceneTagService(globalApplicationContext);
		yield sentenceService.addSceneTag(action.payload);
		yield put(addSceneTagSuccess({}));
		toast('Scene tag created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(addSceneTagFailure({}));
	}
}

function* getSceneTagToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SceneTagService(globalApplicationContext);
		const data = yield sentenceService.getSceneTagById(action.payload);
		yield put(getSceneTagToUpdateSuccess(data));
	} catch (e) {
		yield put(getSceneTagToUpdateFailure({}));
	}
}

function* updateSceneTagHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SceneTagService(globalApplicationContext);
		yield sentenceService.updateSceneTag(action.payload);
		yield put(updateSceneTagSuccess(action.payload));
		toast('Scene tag updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateSceneTagFailure({}));
	}
}

// --

function* getSceneCardsListHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SceneCardService(globalApplicationContext);
		const data = yield sentenceService.getSceneCards(
			action.payload.page,
			action.payload,
		);
		yield put(getSceneCardsSuccess(data));
	} catch (e) {
		yield put(getSceneCardsFailure(e));
		console.error(e);
	}
}

function* searchSceneCardsHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SceneCardService(globalApplicationContext);
		const data = yield sentenceService.searchSceneCardsAutoComplete(
			action.payload,
		);
		yield put(setSearchSceneCardsAutoCompleteResult(data));
	} catch (e) {
		console.error(e);
	}
}

function* deleteSceneCardHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SceneCardService(globalApplicationContext);
		yield sentenceService.deleteSceneCard(action.payload);
		yield put(deleteSceneCardSuccess({}));
		toast('Scene card deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteSceneCardFailure(e));
		console.error(e);
	}
}

function* addSceneCardHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SceneCardService(globalApplicationContext);
		yield sentenceService.addSceneCard(action.payload);
		yield put(addSceneCardSuccess({}));
		toast('Scene card created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(addSceneCardFailure({}));
	}
}

function* getSceneCardToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SceneCardService(globalApplicationContext);
		const data = yield sentenceService.getSceneCardById(action.payload);
		yield put(getSceneCardToUpdateSuccess(data));
	} catch (e) {
		yield put(getSceneCardToUpdateFailure({}));
	}
}

function* updateSceneCardHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new SceneCardService(globalApplicationContext);
		yield sentenceService.updateSceneCard(action.payload);
		yield put(updateSceneCardSuccess(action.payload));
		toast('Scene card updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateSceneCardFailure({}));
	}
}

// --

function* getScenesGroupsListHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new ScenesGroupService(globalApplicationContext);
		const data = yield sentenceService.getScenesGroups(
			action.payload.page,
			action.payload,
		);
		yield put(getScenesGroupsSuccess(data));
	} catch (e) {
		yield put(getScenesGroupsFailure(e));
		console.error(e);
	}
}

function* searchScenesGroupsHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new ScenesGroupService(globalApplicationContext);
		const data = yield sentenceService.searchScenesGroupsAutoComplete(
			action.payload,
		);
		yield put(setSearchScenesGroupsAutoCompleteResult(data));
	} catch (e) {
		console.error(e);
	}
}

function* deleteScenesGroupHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new ScenesGroupService(globalApplicationContext);
		yield sentenceService.deleteScenesGroup(action.payload);
		yield put(deleteScenesGroupSuccess({}));
		toast('Scenes group deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteScenesGroupFailure(e));
		console.error(e);
	}
}

function* addScenesGroupHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new ScenesGroupService(globalApplicationContext);
		yield sentenceService.addScenesGroup(action.payload);
		yield put(addScenesGroupSuccess({}));
		toast('Scenes group created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(addScenesGroupFailure({}));
	}
}

function* getScenesGroupToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new ScenesGroupService(globalApplicationContext);
		const data = yield sentenceService.getScenesGroupById(action.payload);
		yield put(getScenesGroupToUpdateSuccess(data));
	} catch (e) {
		yield put(getScenesGroupToUpdateFailure({}));
	}
}

function* updateScenesGroupHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const sentenceService = new ScenesGroupService(globalApplicationContext);
		yield sentenceService.updateScenesGroup(action.payload);
		yield put(updateScenesGroupSuccess(action.payload));
		toast('Scenes group updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateScenesGroupFailure({}));
	}
}

export function* sceneMatchingSaga(): Generator<any, any, any> {
	yield all([
		takeEvery(getSceneTags, getSceneTagsListHandler),
		takeEvery(deleteSceneTag, deleteSceneTagHandler),
		takeEvery(addSceneTag, addSceneTagHandler),
		takeEvery(getSceneTagToUpdate, getSceneTagToUpdateHandler),
		takeEvery(updateSceneTag, updateSceneTagHandler),
		takeEvery(searchSceneTags, searchSceneTagsHandler),

		takeEvery(getSceneCards, getSceneCardsListHandler),
		takeEvery(deleteSceneCard, deleteSceneCardHandler),
		takeEvery(addSceneCard, addSceneCardHandler),
		takeEvery(getSceneCardToUpdate, getSceneCardToUpdateHandler),
		takeEvery(updateSceneCard, updateSceneCardHandler),
		takeEvery(searchSceneCards, searchSceneCardsHandler),

		takeEvery(getScenesGroups, getScenesGroupsListHandler),
		takeEvery(deleteScenesGroup, deleteScenesGroupHandler),
		takeEvery(addScenesGroup, addScenesGroupHandler),
		takeEvery(getScenesGroupToUpdate, getScenesGroupToUpdateHandler),
		takeEvery(updateScenesGroup, updateScenesGroupHandler),
		takeEvery(searchScenesGroups, searchScenesGroupsHandler),
	]);
}
